import React from 'react';

const Header = () => {
    return (
        <header className="header">
            <h1>CONNECT ALL (SL) LTD</h1>
            <nav>
                <ul>
                    <li>Home</li>
                    <li>About</li>
                    <li>Services</li>
                    <li>Contact</li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;